import { render, staticRenderFns } from "./BaseRestaurantCell.vue?vue&type=template&id=4e990cd5&"
import script from "./BaseRestaurantCell.vue?vue&type=script&lang=js&"
export * from "./BaseRestaurantCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports